import { render, staticRenderFns } from "./AiTraffic.vue?vue&type=template&id=07a806e6&scoped=true"
import script from "./AiTraffic.vue?vue&type=script&lang=js"
export * from "./AiTraffic.vue?vue&type=script&lang=js"
import style0 from "./AiTraffic.vue?vue&type=style&index=0&id=07a806e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a806e6",
  null
  
)

export default component.exports